import React from 'react';
import { useSelector } from 'react-redux';
import CartHeader from '@nykaa/cart-shared/components/Header';
import { CART_TEXT_MESSAGES } from '@nykaa/cart-shared/constants/message';
import { stringInterpolation } from '@nykaa/cart-shared/helpers/utils';
import { HeaderLayout } from '../../styled';
import { State } from 'store/types';
import { useIsLoggedIn } from 'hooks/auth';
import { pages } from 'constants/urls';
import { gotoUrl } from 'shared/helpers/shoppingBag';

interface Props {
  showPickFreeSampleScreen: boolean;
  handleFreeSampleBack: () => void;
}

const Header = ({ showPickFreeSampleScreen, handleFreeSampleBack }: Props) => {
  const isLoggedIn = useIsLoggedIn();
  const { quantity } = useSelector(
    (state: State) => state.cartReducer.cartInfo
  );
  const { freeSampleMessage = '' } = useSelector(
    (state: State) => state.cartReducer.freeSamples
  ) || { freeSampleMessage: '' };
  const cartUpdatedDesignEnabled = useSelector(
    (state: State) => state.remoteConfig.switches?.cartDesignUpdate
  );

  const { DYNAMIC_ITEMS, DYNAMIC_ITEM, BAG, VIEW_WISHLIST, SHOPPING_BAG } =
    CART_TEXT_MESSAGES;

  let title = BAG;
  let wishlistBtnText = VIEW_WISHLIST;
  if (!isLoggedIn) {
    wishlistBtnText = '';
  }

  let subTitle = '';

  if (quantity) {
    subTitle = stringInterpolation(
      quantity > 1 ? DYNAMIC_ITEMS : DYNAMIC_ITEM,
      {
        count: quantity,
      }
    );
  }

  if (showPickFreeSampleScreen) {
    title = freeSampleMessage;
    subTitle = '';
    wishlistBtnText = '';
  }

  if (cartUpdatedDesignEnabled) {
    title = `${SHOPPING_BAG} ${quantity > 0 ? `(${quantity})` : ''}`;
    subTitle = '';
  }

  const handleWishlist = () => {
    gotoUrl(pages.WISHLIST_PAGE);
  };

  const handleBack = () => {
    if (showPickFreeSampleScreen) {
      handleFreeSampleBack();
      return;
    }
    (window as any)?.closeCart();
  };

  const config = {
    isGuest: !isLoggedIn,
    title,
    subTitle,
    wishlistBtn: {
      text: wishlistBtnText,
      action: handleWishlist,
    },
    leadingIconAction: handleBack,
    overrides: {
      style: {
        position: 'absolute',
      },
    },
    ariaLevel: 2,
  };

  return (
    <HeaderLayout data-test-id="header">
      <CartHeader {...config} />
    </HeaderLayout>
  );
};

export default Header;
